// PepSanctionsCardStyles.pdf.js
import { StyleSheet } from "@react-pdf/renderer";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";

const pepSanPdfStyles = StyleSheet.create({
  // ---------- layout ----------
  group: {
    width: "100%",
    gap: 10,
  },
  typeHeadingRow: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 6,
  },
  typeDivider: {
    height: 1,
    backgroundColor: "transparent",
    flex: 1,
    marginLeft: 10,
  },

  // ---------- banner (UI Banner equivalent) ----------
  banner: {
    width: "100%",
    borderWidth: 1,
    borderColor: theme.colors.Warning,
    backgroundColor: theme.colors.Yellow400,
    borderRadius: 3,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },

  // ---------- card ----------
  card: {
    width: "100%",
    // borderWidth: 0,
    // border: "none",
    borderColor: theme.colors.Grey25,
    borderRadius: 8,
    backgroundColor: theme.colors.White,
    padding: 12,
    gap: 10,
  },

  cardHeader: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 12,
  },

  headerLeft: {
    flex: 1,
    flexDirection: "column",
    gap: 6,
  },

  headerRight: {
    width: 140,
    alignItems: "flex-end",
    justifyContent: "flex-start",
    gap: 6,
  },

  // ---------- ref pill ----------
  refPill: {
    alignSelf: "flex-start",
    backgroundColor: theme.colors.White,
    borderWidth: 1,
    borderColor: theme.colors.Grey400,
    borderRadius: 999,
    paddingVertical: 3,
    paddingHorizontal: 10,
    color:theme.colors.White,
  },

  // ---------- meta grid ----------
  metaGrid: {
    flexDirection: "row",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "flex-start",
      alignItems: "center",
    gap: 6,
  },
  metaItem: {
    borderWidth: 1,
    borderColor: theme.colors.Grey10,
    backgroundColor: theme.colors.White,
    borderRadius: 6,
    paddingVertical: 6,
    paddingHorizontal: 8,
    // minWidth: 150,

    // width: "33.33%",
  },
  metaLabelRow: {
    flexDirection: "row",
    alignItems: "baseline",
    gap: 4,
  },

  // ---------- outcome chip ----------
  //   outcomeChip: {
  //     borderRadius: 999,
  //     paddingVertical: 5,
  //     paddingHorizontal: 10,
  //     borderWidth: 1,
  //   },
  //   outcomeRefer: {
  //     backgroundColor: theme.colors.Yellow400,
  //     borderColor: theme.colors.Warning,
  //   },
  //   outcomeNotClient: {
  //     backgroundColor: theme.colors.Green400,
  //     borderColor: theme.colors.Success,
  //   },
  //   outcomeUnresolved: {
  //     backgroundColor: theme.colors.Red400,
  //     borderColor: theme.colors.error,
  //   },

  // ---------- blocks ----------
  block: {
    width: "100%",
    borderTopWidth: 1,
    borderTopColor: theme.colors.White,
    paddingTop: 8,
    gap: 6,
  },
  blockTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  // bullet list
  bulletList: {
    gap: 3,
  },
  bulletRow: {
    flexDirection: "row",
    gap: 6,
    width:"95%",
  },
  bulletDot: {
    width: 10,
    textAlign: "center",
  },

  // ---------- chips ----------
  chipWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  chip: {
    borderWidth: 1,
    borderColor: theme.colors.Grey25,
    backgroundColor: theme.colors.White,
    borderRadius: 999,
    paddingVertical: 4,
    paddingHorizontal: 8,
  },

  // ---------- sanction mini-card ----------
  sanctionCard: {
    width: "100%",
    borderWidth: 1,
    borderColor: theme.colors.Grey10,
    backgroundColor: theme.colors.White,
    borderRadius: 8,
    padding: 10,
    gap: 4,
  },

  // ---------- small helpers ----------
  muted: {
    color: theme.colors.Grey600,
  },
});

export default pepSanPdfStyles;
